module.exports = __webpack_public_path__ + "static/media/available-selected.4e2dc22c.svg";